import { Row, Col, Form, Input, Select } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_indemoscreen_form } from "../../actions/form_slice";
import { debounce } from "lodash";
const { Option } = Select;

const INDEMOSCREEN = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.indemoscreen_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_indemoscreen_form(changedValues));
    onValuesChange(formData);
  }, 300);

  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="vertical"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Row style={{ marginTop: 15 }}>
        <Col span={16} style={{ fontWeight: "bold" }}>
          Screen Name: INDIVIDUAL DEMOGRAPHICS SCREEN (All Programs)
        </Col>
        <Col span={8}>
          <Form.Item
            name="Status"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select defaultValue="Selected Status" style={{ width: 200 }}>
              <Option value="Selected Status">
                <strong>Selected Status</strong>
              </Option>
              <Option value="COMPLETE">COMPLETE</Option>
              <Option value="PENDING">PENDING</Option>
            </Select>
          </Form.Item>
        </Col>
        <Row>
          <label>Individual Demographics List Screen</label>
        </Row>
        <Row>
          <label>MUST COMPLETE IN KEES FOR EACH HH MEMBER</label>
        </Row>
        <Row>
          <label>
            IF THE SSN VERIFICATION FIELD SAYS HUB-SSA, SSA-SVES OR GOOD CAUSE
            DO NOT UPDATE THIS FIELD.
          </label>
        </Row>
      </Row>

      <Form.Item name="Comments" label="Comments">
        <Input style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item name="Pending for" label="Pending for:">
        <Input style={{ width: "100%" }} />
      </Form.Item>
    </Form>
  );
});
export default INDEMOSCREEN;
